export const vs2jen2GlobalReleaseConstants = {
  VS2JEN2_GLOBAL_RELEASE_LOADING: "VS2JEN2_GLOBAL_RELEASE_LOADING",
  VS2JEN2_GLOBAL_RELEASE_SUCCESS: "VS2JEN2_GLOBAL_RELEASE_SUCCESS",
  VS2JEN2_GLOBAL_RELEASE_FAILURE: "VS2JEN2_GLOBAL_RELEASE_FAILURE",
};

export const addVs2jen2GlobalReleaseConstants = {
  ADD_VS2JEN2_GLOBAL_RELEASE_LOADING: "ADD_VS2JEN2_GLOBAL_RELEASE_LOADING",
  ADD_VS2JEN2_GLOBAL_RELEASE_SUCCESS: "ADD_VS2JEN2_GLOBAL_RELEASE_SUCCESS",
  ADD_VS2JEN2_GLOBAL_RELEASE_FAILURE: "ADD_VS2JEN2_GLOBAL_RELEASE_FAILURE",
};

export const editVs2jen2GlobalReleaseConstants = {
  EDIT_VS2JEN2_GLOBAL_RELEASE_LOADING: "EDIT_VS2JEN2_GLOBAL_RELEASE_LOADING",
  EDIT_VS2JEN2_GLOBAL_RELEASE_SUCCESS: "EDIT_VS2JEN2_GLOBAL_RELEASE_SUCCESS",
  EDIT_VS2JEN2_GLOBAL_RELEASE_FAILURE: "EDIT_VS2JEN2_GLOBAL_RELEASE_FAILURE",
};
